import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  HRVSummarySearchRequest,
  SearchedIndividualSummary,
  searchHRVSummaryApi,
} from 'api/analysisApi'
import {openFailureModalAction} from 'features/modal/alertSlice'
import {getDefaultPeriodString, periodStringToDate} from 'helpers/dateHelper'
import {RootState} from 'store'

export const searchHrvSummary = createAsyncThunk(
  'api/hrv/summary/search',
  async (payload: HRVSummarySearchRequest, {rejectWithValue, dispatch}) => {
    try {
      const response = await searchHRVSummaryApi(payload)
      return response.data
    } catch (err) {
      await dispatch(openFailureModalAction(err.message))
      return rejectWithValue(err.message)
    }
  },
)

interface HRVSummaryState {
  loading: boolean
  error: any
  items: SearchedIndividualSummary[]
  period: PeriodString
  search: AnalysisSearchKind
  paging: Paging
  pagingInfo: {
    totalPages: number
    totalElements: number
  }
}

const initialState: HRVSummaryState = {
  loading: false,
  error: null,
  items: [],
  period: getDefaultPeriodString(), // TODO: redux 데이트 나래와 논의
  search: {searchName: 'NAME', searchValue: ''},
  paging: {page: 0, size: 10},
  pagingInfo: {
    totalPages: 1,
    totalElements: 0,
  },
}

const slice = createSlice({
  name: 'hrvSummarySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchHrvSummary.pending, (state, action) => {
      state.loading = true
      state.error = null

      const {period, search} = action.meta.arg
      state.search = search
      state.period = period
    })
    builder.addCase(searchHrvSummary.fulfilled, (state, action) => {
      state.loading = false
      const {
        content: items,
        pageable: {pageNumber: page},
        size,
        totalPages,
        totalElements,
      } = action.payload
      state.items = items
      state.paging.page = page
      state.paging.size = size
      state.pagingInfo.totalElements = totalElements
      state.pagingInfo.totalPages = totalPages
    })
    builder.addCase(searchHrvSummary.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })
  },
})

export default slice.reducer

export const selectLoading = (state: RootState) => state.hrvSummary.loading
export const selectError = (state: RootState) => state.hrvSummary.error
export const selectItems = (state: RootState) => state.hrvSummary.items
export const selectPeriod = (state: RootState) =>
  periodStringToDate(state.hrvSummary.period)
export const selectSearch = (state: RootState) => state.hrvSummary.search
export const selectPaging = (state: RootState) => state.hrvSummary.paging
export const selectPagingInfo = (state: RootState) =>
  state.hrvSummary.pagingInfo

export const selectQuery = (state: RootState) => ({
  period: state.hrvSummary.period,
  search: state.hrvSummary.search,
  paging: state.hrvSummary.paging,
})
